const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['請假單', '請假單', '請假單'],
				children: {
					ZZ_PADAUK_WF10010: {
						name: ['請假不合併計算假勤設定', '請假不合併計算假勤設定', '請假不合併計算假勤設定'],
						url: '/zz_padauk_wf10010',
						hint: [],
					},
					ZZ_PADAUK_WF10020: {
						name: ['假勤職務代理人順序設定', 'Agent Sort', '假勤职务代理人顺序设定'],
						url: '/zz_padauk_wf10020',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};